import { render, staticRenderFns } from "./MemberWhatsapp.vue?vue&type=template&id=21837d7e&"
import script from "./MemberWhatsapp.vue?vue&type=script&lang=js&"
export * from "./MemberWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports